export default function uniquePmDocumentNameDirective(
  $q,

  pmDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const documentId = attributes.documentId || 0;
    ngModel.$asyncValidators.uniquePmDocumentName = (modelValue) => {
      const defer = $q.defer();
      pmDataService.checkDocumentExists(
        documentId,
        modelValue
      ).then((checkDocumentExistsResponse) => {
        if (
          checkDocumentExistsResponse
          && checkDocumentExistsResponse.data.result === false
        ) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'uniquePmDocumentName';

uniquePmDocumentNameDirective.$inject = [
  '$q',

  'pmDataService'
];
